import BaseModel from './base';
import { DEFAULT_NOMINATION } from '@/modules/Events/constants.js';
import Group from './group';
import { smartNumberSort } from '@/modules/UIDesign/functions';

export default class Nomination extends BaseModel {
  constructor(nomination, url) {
    super(nomination, url);

    this.id = nomination.id;
    this.name = nomination.name === DEFAULT_NOMINATION.KEY ? DEFAULT_NOMINATION.NAME : nomination.name;
    this.groups = smartNumberSort((nomination.groups || []).map((group) => new Group(group, 'event-groups')), 'name');

    // from /events/:id expand: 'nominations'
    this.image = nomination?.image || null;
    // from /nominations
    this.directory_nomination_id = nomination?.directory_nomination_id || null;

    this.options = nomination.options || null;
  }

  get isBase() {
    return this.name === DEFAULT_NOMINATION.NAME;
  }

  get hasGroups() {
    return !!this.groups.length;
  }

  get actualGroups() {
    if (this.groups.length > 1) {
      return this.groups.filter((group) => !group.isBaseCategory);
    }
    return this.groups;
  }
}
